import { render, staticRenderFns } from "./404_page.vue?vue&type=template&id=6042cae4&scoped=true&"
import script from "./404_page.vue?vue&type=script&lang=js&"
export * from "./404_page.vue?vue&type=script&lang=js&"
import style0 from "./404_page.vue?vue&type=style&index=0&id=6042cae4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6042cae4",
  null
  
)

export default component.exports